import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import AnnotationComponent from './Content';
import { StyledAnnotationModal, StyledOverlay } from './styled';

import { OPEN_ANNOTATION_EVENT } from './annotationEvent';

const annotationModal = document.getElementById('annotation-modal') as HTMLFormElement;

const AnnotationModal = () => {

  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState(null);

  const handleAnnotationEvent = ({ detail }: any) => {
    setDetail(detail);
    setOpen(true);
  }

  useEffect(() => {
    document.addEventListener(OPEN_ANNOTATION_EVENT, handleAnnotationEvent);
    return () => document.removeEventListener(OPEN_ANNOTATION_EVENT, handleAnnotationEvent);
  }, []);

  if (!open) return null;
  return ReactDOM.createPortal(
    <>
      <StyledOverlay></StyledOverlay>
      <StyledAnnotationModal>
        <AnnotationComponent {...detail} setOpen={setOpen} />
      </StyledAnnotationModal>
    </>,
    annotationModal
  )

};

export default AnnotationModal;
